import { render, staticRenderFns } from "./myAiAudio.vue?vue&type=template&id=27db9458&scoped=true&"
import script from "./myAiAudio.vue?vue&type=script&lang=js&"
export * from "./myAiAudio.vue?vue&type=script&lang=js&"
import style0 from "./myAiAudio.vue?vue&type=style&index=0&id=27db9458&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db9458",
  null
  
)

export default component.exports